var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharedownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.499 7.21256L16.499 2.71289M16.499 2.71289H11.9993M16.499 2.71289L10.4994 8.71245M8.24961 4.21278H6.59974C5.33971 4.21278 4.7097 4.21278 4.22843 4.458C3.8051 4.6737 3.46092 5.01788 3.24522 5.44121C3 5.92248 3 6.55249 3 7.81252V12.6122C3 13.8722 3 14.5022 3.24522 14.9835C3.46092 15.4068 3.8051 15.751 4.22843 15.9667C4.7097 16.2119 5.33971 16.2119 6.59974 16.2119H11.3994C12.6594 16.2119 13.2894 16.2119 13.7707 15.9667C14.194 15.751 14.5382 15.4068 14.7539 14.9835C14.9991 14.5022 14.9991 13.8722 14.9991 12.6122V10.9623",
    stroke: "#6A4FF5",
    strokeWidth: 1.49989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharedownload);
export default __webpack_public_path__ + "static/media/share.download.5d0e3f4d022831e99533b10695ccda46.svg";
export { ForwardRef as ReactComponent };